import { render, staticRenderFns } from "./ClaimRecordNew.vue?vue&type=template&id=51ea3707"
import script from "./ClaimRecordNew.vue?vue&type=script&lang=js"
export * from "./ClaimRecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports